import { Box, VStack } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { BrandBar } from '../../components/BrandBar'
import { TitleHeader } from '../../components/TitleHeader'
import { CampaignBanner } from '../components/CampaignBanner'
import { CurrentCoinDisplay } from '../components/CurrentCoinDisplay'
import { CoinPlanList } from '../components/CoinPlanList'
import { FooterLinks } from '../components/FooterLinks'
import { useLogout } from '../../hooks/useLogout'

export const CoinPurchase = ({ currentCoinCount, coinPlans }) => {
  const navigate = useNavigate()
  const { logout, isLoading: isLogoutLoading } = useLogout()

  const handlePlanSelect = (productId) => {
    // 購入方法選択画面に遷移
    navigate(`/select_payment_method?product_id=${productId}`)
  }

  return (
    <Box minH="100vh" bg="background.default" display="flex" justifyContent="center">
      <Box w="100%" maxW="500px">
        <VStack spacing={0} align="stretch">
          <BrandBar onLogout={logout} isLogoutLoading={isLogoutLoading} />
          <TitleHeader title="コイン購入" />
          <CampaignBanner />
          <CurrentCoinDisplay coinCount={currentCoinCount} />
          <CoinPlanList coinPlans={coinPlans} onPlanSelect={handlePlanSelect} />
          <FooterLinks />
        </VStack>
      </Box>
    </Box>
  )
}
